import * as Polyglot from 'node-polyglot';

export type Phrases = {[key: string]: string};

export class Lang {
  static getPhrases(lang?: string): Promise<Phrases> {
    /* tslint:disable */
    try {
      return require(`../../locales/${lang}.json`);
    } catch (err) {
      return require('../../locales/en.json');
    }
    /* tslint:enable */
  }

  static setLanguage(lang: string) {
    polyglot.locale(lang);
    polyglot.replace(Lang.getPhrases(lang));
  }
}

export const polyglot = new Polyglot({allowMissing: true, phrases: Lang.getPhrases()});
